/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import MsDyn365, { IGridSettings, IImageData, Image, RichText, RichTextComponent } from '@msdyn365-commerce/core';

import * as React from 'react';
import { htmltoText } from '../../Utilities/analytics/htmlToText';
import classname from 'classnames';

interface IContentData {
    image: IImageData | undefined;
    contentIndex: number;
    title: RichText;
    gridSettings: IGridSettings;
    linkTo: string;
    cardColor: string;
    titleColor: string;
}

export default (props: IContentData) => {
    const styles = 'mfrm-slider-navigation__';
    const {
        image,
        title,
        gridSettings,
        linkTo,
        contentIndex,
        cardColor,
        titleColor
    } = props;

    const cardBkgColor = cardColor === 'white' ? `${styles}cardBkgColor-white` : '';
    const colorOfTitle = titleColor ? `${styles}text-${titleColor}` : '';
    const bkgImage = typeof image !== 'undefined' ?
    <Image {...image} alt={image?.altText} className={`${styles}disruptor-image`} src={image?.src || ''} gridSettings={gridSettings} />
    : null;

    const button = !image ?
    <div className={classname(`${styles}red-cta`)}>Start</div>
    : null;

    const handleClick = () => {
        if (MsDyn365.isBrowser) {
            const titleDisplayed = htmltoText(title.toString()).trim();
            const pageURL = MsDyn365.isBrowser && window.location.pathname;
                // @ts-ignore
                if ('utag' in window) {
                    // @ts-ignore
                    utag.link({
                        event: 'sleep-disruptor-nav-module',
                        event_category: 'sleep disruptor nav module',
                        event_action: `${titleDisplayed} click - position ${contentIndex + 1}`,
                        event_label: `sleep disruptor ${pageURL}`,
                        event_noninteraction: 'false'
                    });
                }
            window.location.href = linkTo;
        }
    };

    const analyticsRef = React.useRef<any>();
    React.useEffect(() => {
        analyticsRef.current && analyticsRef.current.addEventListener('click', handleClick);
    }, []);

    return (
        <a
            ref={analyticsRef}
            href={linkTo}
            className={`${styles}link`}
        >
            <div className={classname(cardBkgColor, image ? `${styles}disruptor` : '', !image ? `${styles}disruptor-no-image`: '')}>
                {bkgImage}
                <div className={classname(image ? `${styles}text-container-disruptor` : '', !image ? `${styles}text-container-disruptor-no-image` : '')}>
                    <div className={classname(image ? `${styles}title-disruptor` : '', !image ? `${styles}title-disruptor-no-image` : '', colorOfTitle)}>
                        <RichTextComponent text={title} />
                    </div>
                    {button}
                </div>
            </div>
        </a>
    );
};
